import React from "react";
import SubmitIcon from "../../icon/SubmitIcon";

const BlockButton = ({ type, text }) => {
  return (
    <button
      type={type}
      className="py-2.5 px-5 flex items-center justify-center gap-x-3 w-full text-sm font-medium rounded bg-gray-700 text-white border border-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 hover:bg-gray-800"
    >
      {text}
      <SubmitIcon />
    </button>
  );
};

export default BlockButton;
